import { Menu } from "@headlessui/react";

export const WebPagesContextMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
    handlePublishWebPage,
    handleUpdateCDNWebPage,
    handleCDNResetClick,
    handleCDNDeleteClick,
    handleEnableSEOAccountWebPage,
    handleSave,
    handleUpdateTenantWebsite,
    handleEnableTenantWebsite,
    handleClickReset,
    row
}) => {
    return (
        <>
        <Menu as="div" className="relative text-left">
														<div>
															<Menu.Button
																onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
																className="pt-1 pl-1 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	fill="currentColor"
																	viewBox="0 0 24 24"
																	width="18"
																	height="18"
																>
																	<circle cx="12" cy="5" r="2" />
																	<circle cx="12" cy="12" r="2" />
																	<circle cx="12" cy="19" r="2" />
																</svg>
															</Menu.Button>
														</div>

														{anchorShipmentEl && (
															<Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }}>
																<div className="px-1 py-1">
																	{/* CDN Related Actions Section */}
																	<div className="px-2 py-1 font-semibold text-gray-700 underline">CDN Related Actions</div>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handlePublishWebPage(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black ${row.TableUrl === null && row.CDNEndpointUrl === null ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'
																					}`}
																				title="Publish tenant Websites in CDN"
																				disabled={!(row.TableUrl === null && row.CDNEndpointUrl === null)}
																			>
																				Publish in CDN
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleUpdateCDNWebPage(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title="Add Newly updated Cards to the Web pages already  published in CDN"
																			>
																				Add new cards in CDN
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleCDNResetClick(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title="To reset the Web pages already published in CDN"
																			>
																				Reset Webpage in CDN
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleCDNDeleteClick(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title="To delete  the Web pages published in CDN"
																			>
																				Delete webpage in CDN
																			</button>
																		)}
																	</Menu.Item>

																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleEnableSEOAccountWebPage(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black ${row.BlobFolderUrl === null ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'
																					}`}
																				title="To enable the blog folder for already created website"
																				disabled={!(row.BlobFolderUrl === null)}
																			>
																				Enable SEO Folder
																			</button>
																		)}
																	</Menu.Item>

																	{/* WebPage Related Logic Section */}
																	<div className="px-2 py-1 font-semibold text-gray-700 underline">Websites Related Actions</div>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleSave(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title="Update Account web page  details"
																			>
																				Update Account web page
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleUpdateTenantWebsite(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}

																				title='Add New Updated cards published in Platform Website'
																			>
																				Add NewCards to Webpages
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleEnableTenantWebsite(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}

																				title='To activate Disabled Web pages'
																			>
																				Enable to Account web page
																			</button>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleClickReset(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
																				title='Reset the current website and create new records  with Platform Website'
																			>
																				Reset Account web page
																			</button>
																		)}

																	</Menu.Item>

																</div>
															</Menu.Items>
														)}
													</Menu>
        </>
    )
}